"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ItemAligner {
    constructor(_line) {
        this._line = _line;
        this.crossAxisLayoutSize = 0;
        this.crossAxisLayoutOffset = 0;
        this.recursiveResizeOccured = false;
        this.isCrossAxisFitToContents = false;
    }
    get _layout() {
        return this._line.getLayout();
    }
    get _flexContainer() {
        return this._layout.container;
    }
    setCrossAxisLayoutSize(size) {
        this.crossAxisLayoutSize = size;
    }
    setCrossAxisLayoutOffset(offset) {
        this.crossAxisLayoutOffset = offset;
    }
    align() {
        this.alignItemsSetting = this._flexContainer.alignItems;
        this.isCrossAxisFitToContents = this._layout.isAxisFitToContents(!this._flexContainer.horizontal);
        this.recursiveResizeOccured = false;
        const items = this._line.items;
        for (let i = this._line.startIndex; i <= this._line.endIndex; i++) {
            const item = items[i];
            this._alignItem(item);
        }
    }
    getRecursiveResizeOccured() {
        return this.recursiveResizeOccured;
    }
    _alignItem(item) {
        const flexItem = item.flexItem;
        let align = flexItem.alignSelf || this.alignItemsSetting;
        if (align === "stretch" && this.preventStretch(flexItem)) {
            align = "flex-start";
        }
        if (align !== "center" && !this.isCrossAxisFitToContents) {
            if (flexItem.hasRelCrossAxisSize()) {
                // As cross axis size might have changed, we need to recalc the relative flex item's size.
                flexItem.resetCrossAxisLayoutSize();
            }
        }
        switch (align) {
            case "flex-start":
                this._alignItemFlexStart(flexItem);
                break;
            case "flex-end":
                this._alignItemFlexEnd(flexItem);
                break;
            case "center":
                this._alignItemFlexCenter(flexItem);
                break;
            case "stretch":
                this._alignItemStretch(flexItem);
                break;
        }
    }
    _alignItemFlexStart(flexItem) {
        flexItem.setCrossAxisLayoutPos(this.crossAxisLayoutOffset);
    }
    _alignItemFlexEnd(flexItem) {
        const itemCrossAxisSize = flexItem.getCrossAxisLayoutSizeWithPaddingAndMargin();
        flexItem.setCrossAxisLayoutPos(this.crossAxisLayoutOffset + (this.crossAxisLayoutSize - itemCrossAxisSize));
    }
    _alignItemFlexCenter(flexItem) {
        const itemCrossAxisSize = flexItem.getCrossAxisLayoutSizeWithPaddingAndMargin();
        const center = (this.crossAxisLayoutSize - itemCrossAxisSize) / 2;
        flexItem.setCrossAxisLayoutPos(this.crossAxisLayoutOffset + center);
    }
    _alignItemStretch(flexItem) {
        flexItem.setCrossAxisLayoutPos(this.crossAxisLayoutOffset);
        const mainAxisLayoutSizeBeforeResize = flexItem.getMainAxisLayoutSize();
        let size = this.crossAxisLayoutSize - flexItem.getCrossAxisMargin() - flexItem.getCrossAxisPadding();
        const crossAxisMinSizeSetting = flexItem.getCrossAxisMinSizeSetting();
        if (crossAxisMinSizeSetting > 0) {
            size = Math.max(size, crossAxisMinSizeSetting);
        }
        const crossAxisMaxSizeSetting = flexItem.getCrossAxisMaxSizeSetting();
        const crossAxisMaxSizeSettingEnabled = crossAxisMaxSizeSetting > 0;
        if (crossAxisMaxSizeSettingEnabled) {
            size = Math.min(size, crossAxisMaxSizeSetting);
        }
        flexItem.resizeCrossAxis(size);
        const mainAxisLayoutSizeAfterResize = flexItem.getMainAxisLayoutSize();
        const recursiveResize = mainAxisLayoutSizeAfterResize !== mainAxisLayoutSizeBeforeResize;
        if (recursiveResize) {
            // Recursive resize can happen when this flex item has the opposite direction than the container
            // and is wrapping and auto-sizing. Due to item/content stretching the main axis size of the flex
            // item may decrease. If it does so, we must re-justify-content the complete line.
            // Notice that we don't account for changes to the (if autosized) main axis size caused by recursive
            // resize, which may cause the container's main axis to not shrink to the contents properly.
            // This is by design, because if we had re-run the main axis layout, we could run into issues such
            // as slow layout or endless loops.
            this.recursiveResizeOccured = true;
        }
    }
    preventStretch(flexItem) {
        const hasFixedCrossAxisSize = flexItem.hasFixedCrossAxisSize();
        const forceStretch = flexItem.alignSelf === "stretch";
        return hasFixedCrossAxisSize && !forceStretch;
    }
}
exports.ItemAligner = ItemAligner;
//# sourceMappingURL=ItemAligner.js.map